<template>
  <div class="ts-space-y-2">
    <div class="row ts-mb-3">
      <div class="col-md-12">
        <div class="ts-flex ts-items-center ts-justify-between ts-border-b ts-border-gray-300">
          <div>
            <h3 class="ts-text-sm">{{ $t('availableSchedule.schedule') }}</h3>
          </div>
          <div>
            <a href="#" @click.prevent="addRow">
              <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <div class="ts-space-y-2 ts-pt-2" v-for="(t, index) in model.time_list" :key="index">
          <div class="ts-flex ts-items-baseline ts-space-x-2">
            <a-time-picker
              v-model="t.time"
              use12-hours
              format="hh:mm a"
              valueFormat="hh:m a"
              class="ts-w-full"
            />
            <a
              href="#"
              @click.prevent="removeRow(index)"
              class="ts-text-red-700 hover:ts-text-red-700"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
					<div class="validate ts-text-xs" v-if="errors.has('time_list.' + index + '.time')">
						{{ errors.first('time_list.' + index + '.time') }}
					</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'tableProfileForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        schedule_id: null,
        time_list: [
          {
            time: null
          }
        ]
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('booking/availableSchedule', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    addRow() {
      this.model.time_list.push(
        _.clone({
          time: null
        })
      )
    },
    removeRow(index) {
      this.model.time_list.splice(index, 1)
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('booking/availableSchedule/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('booking/availableSchedule/update', {
          id: this.model.schedule_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.schedule_id = this.edit_data.schedule_id
        this.model.time_list = [{
					time: this.edit_data.schedule_time
				}]
      }
    }
  }
}
</script>